import React from 'react';

// pattern is optional and additive: existing callers that only pass
// color/isStriped/stripeColor keep working exactly as before (isStriped
// maps to pattern="stripes" when pattern itself isn't supplied). Patterns
// that can't be rendered cleanly with this shirt's path geometry (halves,
// sash) intentionally fall back to a solid fill rather than guessing.
const ShirtIcon = ({
  color = "#4caf50",
  width = 80,
  height = 80,
  isStriped = false,
  stripeColor = '#ffffff',
  pattern,
}) => {
  const uid = Math.random().toString(36).substr(2, 9);
  const stripesId = `stripes-${uid}`;
  const hoopsId = `hoops-${uid}`;

  const effectivePattern = pattern || (isStriped ? 'stripes' : 'solid');
  const bodyFill = effectivePattern === 'stripes'
    ? `url(#${stripesId})`
    : effectivePattern === 'hoops'
      ? `url(#${hoopsId})`
      : color;
  const shoulderFill = effectivePattern === 'sleeves' ? stripeColor : bodyFill;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30.000001"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      version="1.2"
    >
      <defs>
        {effectivePattern === 'stripes' && (
          <pattern id={stripesId} patternUnits="userSpaceOnUse" width="3" height="30">
            <rect width="1.5" height="30" fill={color} />
            <rect x="1.5" width="1.5" height="30" fill={stripeColor} />
          </pattern>
        )}
        {effectivePattern === 'hoops' && (
          <pattern id={hoopsId} patternUnits="userSpaceOnUse" width="30" height="4">
            <rect width="30" height="2" fill={color} />
            <rect y="2" width="30" height="2" fill={stripeColor} />
          </pattern>
        )}
      </defs>
    {/* Main shirt body */}
    <path
      d="M 20.992188 11.8125 L 21.613281 27.40625 C 17.167969 28.109375 12.640625 28.109375 8.199219 27.40625 L 8.839844 11.8125 L 8.175781 8.4375 C 8.175781 8.4375 7.160156 4.160156 8.75 3.042969 L 11.671875 1.332031 L 14.910156 1.328125 L 18.152344 1.332031 L 21.085938 3.042969 C 22.671875 4.160156 21.65625 8.4375 21.65625 8.4375 Z M 20.992188 11.8125 "
      fill={bodyFill}
      style={{ stroke: "none", fillRule: "nonzero", fillOpacity: 1 }}
    />
    {/* Left shoulder accent */}
    <path
      d="M 12.78125 2.441406 L 9.039062 4.632812 C 8.3125 5.054688 7.914062 5.878906 8.027344 6.710938 C 8.15625 7.675781 8.371094 8.4375 8.371094 8.4375 C 8.371094 8.4375 8.859375 9.875 8.839844 11.8125 C 8.835938 12.253906 6.183594 12.128906 5.117188 11.125 L 5.457031 7.4375 C 5.609375 5.777344 6.566406 4.292969 8.019531 3.460938 L 11.667969 1.332031 Z"
      fill={shoulderFill}
      style={{ stroke: "none", fillRule: "nonzero", fillOpacity: 1 }}
    />
    {/* Right shoulder accent */}
    <path
      d="M 17.054688 2.441406 L 20.792969 4.632812 C 21.519531 5.054688 21.917969 5.878906 21.804688 6.710938 C 21.675781 7.675781 21.460938 8.4375 21.460938 8.4375 C 21.460938 8.4375 20.972656 9.875 20.992188 11.8125 C 20.996094 12.253906 23.648438 12.128906 24.714844 11.125 L 24.375 7.4375 C 24.222656 5.777344 23.269531 4.292969 21.816406 3.460938 L 18.152344 1.332031 Z"
      fill={shoulderFill}
      style={{ stroke: "none", fillRule: "nonzero", fillOpacity: 1 }}
    />
    {/* Top white highlights */}
    <path
      d="M 20.992188 11.8125 C 20.988281 11.507812 21 11.214844 21.019531 10.9375 C 21.417969 11.234375 23.621094 11.066406 24.632812 10.214844 L 24.714844 11.125 C 23.648438 12.128906 20.996094 12.253906 20.992188 11.8125 Z"
      fill="#fff"
      style={{ stroke: "none", fillRule: "nonzero", fillOpacity: 1 }}
    />
    <path
      d="M 8.839844 11.8125 C 8.84375 11.507812 8.832031 11.214844 8.816406 10.9375 C 8.414062 11.234375 6.210938 11.066406 5.203125 10.214844 L 5.117188 11.125 C 6.183594 12.128906 8.835938 12.253906 8.839844 11.8125 Z"
      fill="#fff"
      style={{ stroke: "none", fillRule: "nonzero", fillOpacity: 1 }}
    />
    {/* Collar highlights */}
    <path
      d="M 5.792969 8.054688 L 5.847656 7.476562 C 5.988281 5.945312 6.875 4.570312 8.214844 3.800781 L 11.957031 1.589844 L 12.039062 1.726562 L 8.292969 3.9375 C 6.996094 4.679688 6.140625 6.007812 6.003906 7.488281 L 5.945312 8.121094 C 5.894531 8.101562 5.84375 8.078125 5.792969 8.054688 Z"
      fill="#fff"
      style={{ stroke: "none", fillRule: "nonzero", fillOpacity: 1 }}
    />
    <path
      d="M 24.039062 8.054688 L 23.984375 7.476562 C 23.84375 5.945312 22.960938 4.570312 21.621094 3.800781 L 17.875 1.589844 L 17.796875 1.726562 L 21.539062 3.9375 C 22.835938 4.679688 23.691406 6.007812 23.828125 7.488281 L 23.886719 8.121094 C 23.9375 8.101562 23.988281 8.078125 24.039062 8.054688 Z"
      fill="#fff"
      style={{ stroke: "none", fillRule: "nonzero", fillOpacity: 1 }}
    />
    {/* Collar ellipse */}
    <path
      d="M 17.53125 0.679688 C 15.851562 1.375 13.96875 1.375 12.289062 0.679688 L 11.667969 1.332031 C 12.121094 2.980469 14.910156 3.804688 14.910156 3.804688 C 14.910156 3.804688 17.699219 2.980469 18.152344 1.332031 Z"
      fill="#fff"
      style={{ stroke: "none", fillRule: "nonzero", fillOpacity: 1 }}
    />
    <path
      d="M 14.910156 3.101562 C 14.910156 3.101562 13.585938 2.617188 12.8125 1.710938 C 14.1875 2.0625 15.632812 2.0625 17.011719 1.710938 C 16.234375 2.617188 14.910156 3.101562 14.910156 3.101562 Z"
      fill="#fff"
      style={{ stroke: "none", fillRule: "nonzero", fillOpacity: 1 }}
    />
    {/* Removed the button circles */}
  </svg>
  );
};

export default ShirtIcon;
